import React from 'react';
import { useSelected } from '@seafile/slate-react';
function Link(props) {
  var className = useSelected() ? 'seafile-ed-hovermenu-mouseclick' : null;
  return /*#__PURE__*/React.createElement("span", Object.assign({}, props.attributes, {
    className: 'virtual-link ' + className
  }), props.children);
}
export default Link;